import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'

const ConsultantFields: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <div style={{ marginTop: '1.5em' }}>
      <Form.Group widths='equal'>
        <FormFields.Input
          name='consultantLastName'
          withoutAsterisk
          control={control}
          placeholder={t('Enter last name')}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Consultant last name')}
            <ErrorIcon control={control} name='consultantLastName' />
          </div>}
          noErrorMessage
          rules={{
            required: true,
            maxLength: {
              value: 50,
              message: t('Maximum 50 characters')
            }
          }}
        />
        <FormFields.Input
          name='consultantFirstName'
          withoutAsterisk
          control={control}
          placeholder={t('Enter first name')}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Consultant first name')}
            <ErrorIcon control={control} name='consultantFirstName' />
          </div>}
          noErrorMessage
          rules={{
            required: true,
            maxLength: {
              value: 50,
              message: t('Maximum 50 characters')
            }
          }}
        />
        <FormFields.Input
          name='consultantPhoneNumber'
          withoutAsterisk
          control={control}
          placeholder={t('Enter phone number')}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Consultant phone number')}
            <ErrorIcon control={control} name='consultantPhoneNumber' />
          </div>}
          noErrorMessage
          rules={{
            required: true,
            maxLength: {
              value: 50,
              message: t('Maximum 50 characters')
            }
          }}
        />
      </Form.Group>
      <Form.Group widths='equal'>
        <FormFields.Input
          name='consultantEmail'
          withoutAsterisk
          control={control}
          placeholder={t('Enter email')}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Consultant email')}
            <ErrorIcon control={control} name='consultantEmail' />
          </div>}
          noErrorMessage
          rules={{
            required: true,
            maxLength: {
              value: 100,
              message: t('Maximum 100 characters')
            }
          }}
        />
        <FormFields.Input
          name='consultantCompanyName'
          withoutAsterisk
          control={control}
          placeholder={t('Enter company name')}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Consultant company')}
            <ErrorIcon control={control} name='consultantCompanyName' />
          </div>}
          noErrorMessage
          rules={{
            required: true,
            maxLength: {
              value: 100,
              message: t('Maximum 100 characters')
            }
          }}
        />
        <Form.Field />
      </Form.Group>
    </div>
  )
}

export default ConsultantFields
